import { convertToMpsBadgeListProps } from './converter.ts';
import { ProductBadgeSize } from '@services/MarppleShop/features/ProductBadge/index.ts';
import { ProductBadgeListView } from '@services/MarppleShop/renderApp/components/cells/ProductBadge/index.ts';
import { NessBadgeListView, convertToNessBadgeProps } from '@modules/Ness/App/ProductBadge';
import { defaultTo, go, html, map, reject, sel, strMap, zipWithIndexL } from 'fxjs/es';
import { MpShopProductTmplS } from '../../../../../../MpShop/Product/S/Tmpl/module/MpShopProductTmplS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { MShopStudioPreDiscountProductS } from '../../../../../Studio/PreDiscountProduct/S/Function/module/MShopStudioPreDiscountProductS.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { makeBaseProductInfoHtml } from './baseProductInfo.js';
import { makeDtgFaqHtml } from './dtgFaq.js';
import { makeDtgPurchaseInfoHtml } from './dtgPurchaseInfo.js';
import { makeFaqHtml } from './faq.js';
import { makePbFaqHtml } from './pbFaq.js';
import { makePbInfoHtml } from './pbInfo.js';
import { makePbPurchaseInfoHtml } from './pbPurchaseInfo.js';
import { makeProductStoryHtml } from './productStory.js';
import { makePurchaseInfoHtml } from './purchaseInfo.js';
import { makeTplFaqHtml } from './tplFaq.js';
import { makeTplPurchaseInfoHtml } from './tplPurchaseInfo.js';
import { messages } from '../../message_id.js';
import { NViewing } from '@services/MarppleShop/renderApp/components/atoms/NViewing/NViewing.ts';
import { makeProdDetailSummaryHtml } from './productDetailSummary.js';
import { makeFanletterHtml, makeRecommendProductsHtml } from './recommendAndFanletter.js';
import {
  CompactCreatorSummary,
  CreatorSummary,
} from '@services/MarppleShop/renderApp/components/cells/CreatorSummary/CreatorSummary.ts';

const func = (item) => (typeof item === 'function' ? item : () => item);

const makeProductNViewingHtml = ({ product_n_viewing_count }) => {
  return new NViewing({
    n: product_n_viewing_count,
    type: 'normal',
    klass: 'pd-preview__n-viewing',
  }).toHtml();
};

// 상품 이미지 슬라이드
export const makeProdImageSlideHtml = ({ product_detail, product_n_viewing_count, is_mobile }) => {
  if (UtilS.isNessApp()) {
    return makeProdImageSlideHtmlNess({ product_detail });
  }

  /**
   * @mps-only
   */
  let thumbnails = go(product_detail, sel('thumbnails.value'), defaultTo([]));
  const thumb_index = thumbnails.findIndex((a) => a.is_thumb);
  const main_index = thumb_index === -1 ? 0 : thumb_index;

  thumbnails = [...thumbnails.slice(main_index), ...thumbnails.slice(0, main_index)];

  const img_alt = go(void 0, () => {
    if (T.lang == 'kr') {
      return `${product_detail['name' + _en]}, 마플샵 제작 상품`;
    } else {
      return `${product_detail['name' + _en]}, MARPPLESHOP GOODS`;
    }
  });

  return html`
    <div class="pd-preview swiper-container" data-len="${thumbnails.length}" data-main-index="${main_index}">
      ${new ProductBadgeListView({
        badges: convertToMpsBadgeListProps(product_detail.mpsProductDetail),
        options: {
          styles: {
            container: 'pd-preview__badges',
          },
          lang: ET.lang,
          size: ProductBadgeSize.medium,
          max_length: 3,
          state: 'MembershipWithLabel',
          baseTimestamp: Date.now(),
        },
      }).toHtmlSSR()}
      ${makeProductNViewingHtml({ product_n_viewing_count, is_mobile })}

      <div class="pd-preview__list swiper-wrapper">
        ${strMap(
          (thumbnail_image) => `
            <div class="pd-preview__item swiper-slide">
              ${MpShopProductTmplS.thumbnail(product_detail, {
                thumbnail_image,
                width: 1480,
                img_alt,
              })}
            </div>
          `,
          thumbnails,
        )}
      </div>

      ${UtilS.htmlIf2(
        is_mobile,
        func(`<div class='swiper-pagination'></div>`),
        func(`
          <div class='swiper-pagination'></div>
          <div class="swiper-button-prev custom">${MShopUtilConstantS.svg.swiper_prev}</div>
          <div class="swiper-button-next custom">${MShopUtilConstantS.svg.swiper_next}</div>
        `),
      )}
    </div>
  `;
};

export const makeCompactCreatorSummary = ({ creator_summary, store }) => {
  const { cart_summary } = creator_summary;
  const isCount = cart_summary && cart_summary?.cart_user_count && cart_summary?.cart_product_count;

  return html`
    <div class="pd-creator-summary ${isCount ? '' : 'disabled'}">
      ${new CompactCreatorSummary({
        ...store,
        ...creator_summary,
        mode: 'compact',
      }).toHtmlSSR()}
    </div>
  `;
};

/**
 * @ness-only
 */
export const makeProdImageSlideHtmlNess = ({ product_detail }) => {
  let thumbnails = go(product_detail, sel('thumbnails.value'), defaultTo([]));
  const thumb_index = thumbnails.findIndex((a) => a.is_thumb);
  const main_index = thumb_index === -1 ? 0 : thumb_index;
  const sp = sel('_.stores_product', product_detail);
  const spo_item_stocks = go(
    product_detail._.spo?._?.spo_items,
    map((spo_item) => spo_item?._?.spo_item_stock),
  );

  const pre_discount_price = sel('_.pre_discount_product.pre_discount_price', product_detail);
  const origin_price = creatorPriceOfProduct(product_detail);
  const pre_discount_rate = pre_discount_price
    ? MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, origin_price)
    : null;

  const main_thumb = thumbnails[main_index];
  thumbnails = [
    main_thumb,
    ...go(
      thumbnails,
      reject((thumb) => thumb === main_thumb),
    ),
  ];

  const img_alt = go(void 0, () => {
    return `${product_detail['name' + _en]}`;
  });

  return html`
    <div class="pd-preview swiper-container" data-len="${thumbnails.length}" data-main-index="${main_index}">
      <div class="pd-preview__list swiper-wrapper">
        ${strMap(
          (thumbnail_image) => `
            <div class="pd-preview__item swiper-slide">
              ${MpShopProductTmplS.thumbnail(product_detail, {
                thumbnail_image,
                width: 1480,
                img_alt,
              })}
            </div>
          `,
          thumbnails,
        )}
      </div>
      <div class="pd-preview__progress swiper-pagination"></div>
      <div class="pd-preview__badges app-product-item--NESS">
        ${new NessBadgeListView(
          convertToNessBadgeProps({
            goods_type_id: sp.goods_type_id,
            spo_item_stocks,
            is_sptg: !!sp?._?.stores_products_token_gates.length,
            ...sp,
            pre_discount_rate,
            lowStockMeta: product_detail.nessProductDetail.lowStockMeta,
            limitedMeta: product_detail.nessProductDetail.limitedMeta,
          }),
        ).toHtmlSSR()}
      </div>
    </div>
  `;
};

// 탭
export const makeTabsHtml = (tabs = []) => {
  return html`
    <div class="pd-tabs">
      ${strMap(
        (tab) =>
          tab.visible
            ? `<div data-key="${tab.key}" class="pd-tabs__item ${tab.active ? 'active' : ''}">
                ${tab.label}
              </div>`
            : '',
        tabs,
      )}
    </div>
  `;
};

const makeNessReviewImageItemTmpl = (prod_id) => (review_image) => {
  return html`
    <div
      class="pd-review-image-item"
      data-article-id="${review_image.id}"
      data-review-id="${review_image._.review.id}"
      data-prod-id="${prod_id}"
    >
      <img src="${review_image._.review.files[0].url}" alt="review image" />
    </div>
  `;
};

const makeProductReviewHtml = ({ review_count }) => {
  return html`
    <div id="pd-review" class="pd-review">
      <h2 class="pd-review__title">${T(messages.tabs.review)} ${review_count || ''}</h2>
      <div class="pd-review__list"></div>
    </div>
  `;
};

const makeNessProductReviewHtml = ({ review_images, prod_id, is_mobile }) => {
  const max_count = is_mobile ? 4 : 7;
  const sliced_list = review_images.slice(0, max_count);

  return html`
    <div id="pd-review" class="pd-review">
      ${review_images.length
        ? `
            <div class="pd-review__images">
              ${strMap(makeNessReviewImageItemTmpl(prod_id), sliced_list)}
              ${
                review_images.length > max_count
                  ? `<button type="button" class="pd-review__images-more" data-prod-id="${prod_id}">
                      ${ET('review::more')}
                    </button>`
                  : ''
              }
            </div>`
        : ''}
      <div class="pd-review__list"></div>
    </div>
  `;
};

// 탭 콘텐츠
export const makeMPSTabContentHtml = ({
  plus_crew,
  product_detail,
  is_mobile,
  store,
  review_images,
  mps_recommended_products,
  is_login,
  creator_summary,
  popup,
}) => {
  const product_story = sel('_.product_story', product_detail);
  const base_product = sel('_.base_product', product_detail);

  if (UtilS.isNessApp()) {
    return html`
      <div tab_name="story">${makeProductStoryHtml(product_story)}</div>
      <div tab_name="bp">${makeBaseProductInfoHtml(base_product, is_mobile)}</div>
      <div tab_name="purchaseInfo">
        ${makePurchaseInfoHtml({ plus_crew, product_detail, store, is_mobile, is_pod: true })}
        ${makeFaqHtml({ plus_crew, is_pod: true })}
      </div>
      <div tab_name="review">
        ${makeNessProductReviewHtml({ review_images, prod_id: product_detail.id, is_mobile })}
      </div>
    `;
  }
  const { fan_letters } = product_detail;
  return html`
    <div class="pd-contents__group pd-info-group" tab_name="product_info">
      <div class="info_el">${makeProdDetailSummaryHtml({ product_detail, store })}</div>
      ${popup
        ? html`
            <div class="info_el">
              <div class="pd-contents__popup"><img src="${popup}" /></div>
            </div>
          `
        : ''}
      <div class="info_el">${makeProductStoryHtml(product_story)}</div>
      <div class="info_el">${makeBaseProductInfoHtml(base_product, is_mobile)}</div>
      <div class="pd-info-group__hide">
        <button type="button" class="pd-info-group__btn">${ET('product_detail::unfold_btn')}</button>
      </div>
    </div>
    <div tab_name="purchaseInfo" class="pd-contents__group">
      ${makePurchaseInfoHtml({ plus_crew, product_detail, store, is_mobile, is_pod: true })}
    </div>
    ${UtilS.htmlIf2(is_mobile && creator_summary, () =>
      new CreatorSummary({
        ...store,
        ...creator_summary,
        is_mobile,
        is_login,
        mode: 'backdrop',
      }).toHtmlSSR(),
    )}
    ${makeRecommendProductsHtml({
      store,
      mps_recommended_products,
      product_detail,
      is_mobile,
      klass: 'pd-contents__group',
    })}
    <div tab_name="fanLetter" class="pd-contents__group">
      ${makeFanletterHtml({ store, fan_letters, is_login, is_mobile })}
    </div>
    <div tab_name="review" class="pd-contents__group">
      ${makeProductReviewHtml({
        review_count: product_detail.review_meta.count,
      })}
    </div>
  `;
};

export const makePBGTabContentHtml = ({
  product_detail,
  is_empty_story,
  store,
  plus_crew,
  review_images,
  mps_recommended_products,
  creator_summary,
  is_mobile,
  is_login,
}) => {
  const product_story = sel('_.product_story', product_detail);
  const {
    _: { stores_product, spo },
    stores_delivery_company,
  } = product_detail;
  const spo_producing_period = spo?._?.spo_producing_period;

  // 브랜드에서 배송을 보내는 경우 예외처리
  const brand_shipping_store_ids = [
    107618, // 크리노브 커머스 > 시골김
    98093, // 샌드박스 > 테라브레스
    103419, // 샌드박스 > 샌드박스커머스2
  ];
  const is_brand_shipping = brand_shipping_store_ids.includes(product_detail.store_id);

  if (UtilS.isNessApp()) {
    return html`
      <div tab_name="story">
        ${is_empty_story ? '' : html`<div class="pd-default-story__dotted"></div>`}
        ${makeProductStoryHtml(product_story)}
      </div>
      <div tab_name="pb_product_info">${makePbInfoHtml(stores_product)}</div>
      <div tab_name="pb_purchaseInfo">
        ${makePbPurchaseInfoHtml({
          plus_crew,
          store,
          stores_product,
          stores_delivery_company,
          spo_producing_period,
        })}
        ${makePbFaqHtml({ store, plus_crew })}
      </div>
      <div tab_name="review">
        ${makeNessProductReviewHtml({ review_images, prod_id: product_detail.id, is_mobile })}
      </div>
    `;
  }

  const i18n = {
    brand_delivery: ET('product_detail::brand_delivery'),
    brand_delivery_desc: ET('product_detail::brand_delivery_desc'),
    creator_delivery: ET('product_detail::creator_delivery'),
    creator_delivery_desc: ET('product_detail::creator_delivery_desc'),
  };
  const { fan_letters } = product_detail;
  return html`
    <div class="pd-contents__group pd-info-group" tab_name="product_info">
      <div class="info_el">
        <div class="info_el">${makeProdDetailSummaryHtml({ product_detail, store })}</div>
        <div class="pd-default-story pd-default-story--pbg">
          <div class="pd-default-story__header">
            ${MShopCoreTmplS.infoCircleIcon()}
            ${is_brand_shipping ? i18n.brand_delivery : i18n.creator_delivery}
          </div>
          <div class="pd-default-story__body pd-default-story__body--pbg">
            ${is_brand_shipping ? i18n.brand_delivery_desc : i18n.creator_delivery_desc}
          </div>
        </div>
        ${is_empty_story ? '' : html`<div class="pd-default-story__dotted"></div>`}
        ${makeProductStoryHtml(product_story)}
      </div>
      <div class="info_el" tab_name="pb_product_info">
        ${makePbInfoHtml({
          product_basic_info:
            stores_product['product_basic_info' + G._en] || stores_product?.product_basic_info,
          certification_info: stores_product['certification_info' + G._en],
          is_kc_cert_checked: stores_product.is_kc_cert_checked,
        })}
      </div>
      <div class="pd-info-group__hide">
        <button type="button" class="pd-info-group__btn">${ET('product_detail::unfold_btn')}</button>
      </div>
    </div>

    <div tab_name="pb_purchaseInfo" class="pd-contents__group">
      ${makePbPurchaseInfoHtml({
        plus_crew,
        store,
        stores_product,
        stores_delivery_company,
        spo_producing_period,
      })}
    </div>
    ${UtilS.htmlIf2(is_mobile && creator_summary, () =>
      new CreatorSummary({
        ...store,
        ...creator_summary,
        is_mobile,
        is_login,
        mode: 'backdrop',
      }).toHtmlSSR(),
    )}
    ${makeRecommendProductsHtml({
      store,
      mps_recommended_products,
      product_detail,
      is_mobile,
      klass: 'pd-contents__group',
    })}
    <div tab_name="fanLetter" class="pd-contents__group">
      ${makeFanletterHtml({ store, fan_letters, is_login, is_mobile })}
    </div>
    <div tab_name="review" class="pd-contents__group">
      ${makeProductReviewHtml({
        review_count: product_detail.review_meta.count,
      })}
    </div>
  `;
};

export const makeTPLTabContentHtml = ({
  product_detail,
  store,
  plus_crew,
  review_images,
  mps_recommended_products,
  creator_summary,
  is_mobile,
  is_login,
  popup,
}) => {
  const product_story = sel('_.product_story', product_detail);
  const {
    _: { stores_product },
  } = product_detail;

  if (UtilS.isNessApp()) {
    return html`
      <div tab_name="story">${makeProductStoryHtml(product_story)}</div>
      <div tab_name="pb_product_info">
        ${makePbInfoHtml({
          product_basic_info: stores_product['product_basic_info' + G._en],
          certification_info: stores_product['certification_info' + G._en],
          is_kc_cert_checked: stores_product.is_kc_cert_checked,
        })}
      </div>
      <div tab_name="pb_purchaseInfo">
        ${makeTplPurchaseInfoHtml({ is_mobile, plus_crew, store, product_detail })}
        ${makeTplFaqHtml({ store, plus_crew })}
      </div>
      <div tab_name="review">
        ${makeNessProductReviewHtml({ review_images, prod_id: product_detail.id, is_mobile })}
      </div>
    `;
  }
  const { fan_letters } = product_detail;
  return html`
    <div class="pd-contents__group pd-info-group" tab_name="product_info">
      <div class="info_el">${makeProdDetailSummaryHtml({ product_detail, store })}</div>
      ${popup
        ? html`
            <div class="info_el">
              <div class="pd-contents__popup"><img src="${popup}" /></div>
            </div>
          `
        : ''}
      <div class="info_el">${makeProductStoryHtml(product_story)}</div>
      <div class="info_el">
        ${makePbInfoHtml({
          product_basic_info:
            stores_product['product_basic_info' + G._en] || stores_product?.product_basic_info,
          certification_info: stores_product['certification_info' + G._en],
          is_kc_cert_checked: stores_product.is_kc_cert_checked,
        })}
      </div>
      <div class="pd-info-group__hide">
        <button type="button" class="pd-info-group__btn">${ET('product_detail::unfold_btn')}</button>
      </div>
    </div>
    <div tab_name="pb_purchaseInfo" class="pd-contents__group">
      ${makeTplPurchaseInfoHtml({ is_mobile, plus_crew, store, product_detail })}
    </div>
    ${UtilS.htmlIf2(is_mobile && creator_summary, () =>
      new CreatorSummary({
        ...store,
        ...creator_summary,
        is_mobile,
        is_login,
        mode: 'backdrop',
      }).toHtmlSSR(),
    )}
    ${makeRecommendProductsHtml({
      store,
      mps_recommended_products,
      product_detail,
      is_mobile,
      klass: 'pd-contents__group',
    })}
    <div tab_name="fanLetter" class="pd-contents__group">
      ${makeFanletterHtml({ store, fan_letters, is_login, is_mobile })}
    </div>
    <div tab_name="review" class="pd-contents__group">
      ${makeProductReviewHtml({
        review_count: product_detail.review_meta.count,
      })}
    </div>
  `;
};

export const makeDTGTabContentHtml = ({
  product_detail,
  is_empty_story,
  store,
  plus_crew,
  review_images,
  mps_recommended_products,
  creator_summary,
  is_mobile,
  is_login,
}) => {
  const product_story = sel('_.product_story', product_detail);
  const {
    _: { stores_product },
    stores_delivery_company,
  } = product_detail;

  if (UtilS.isNessApp()) {
    return html`
      <div tab_name="story">
        <div class="pd-default-story">
          <div class="pd-default-story__header">${T('product_detail::디지털/전자책 구매 안내')}</div>
          <div class="pd-default-story__body">
            <div class="pd-default-story__li">
              ${T(
                'product_detail::결제 완료 후, 구매내역에서 7일 간 다운로드 받으실 수 있습니다. (기한 이후 다운로드를 원하실 경우 재구매를 해주셔야 합니다.)',
              )}
            </div>
            <div class="pd-default-story__li">
              ${T(
                'product_detail::디지털/전자책 특성 상 전자상거래법 제 17조에 의거하여 구매 이후에는 어떠한 사유로도 교환 및 환불이 불가합니다.',
              )}
            </div>
          </div>
        </div>
        ${is_empty_story ? '' : html`<div class="pd-default-story__dotted"></div>`}
        ${makeProductStoryHtml(product_story)}
      </div>
      <div tab_name="pb_purchaseInfo">
        ${makeDtgPurchaseInfoHtml({ plus_crew, store, stores_product, stores_delivery_company })}
        ${makeDtgFaqHtml({ store, plus_crew })}
      </div>
      <div tab_name="review">
        ${makeNessProductReviewHtml({ review_images, prod_id: product_detail.id, is_mobile })}
      </div>
    `;
  }
  const { fan_letters } = product_detail;
  return html`
    <div class="pd-contents__group pd-info-group" tab_name="product_info">
      <div class="info_el">${makeProdDetailSummaryHtml({ product_detail, store })}</div>
      <div class="info_el">
        <div class="pd-default-story">
          <div class="pd-default-story__header">
            ${MShopCoreTmplS.infoCircleIcon()} ${T('product_detail::디지털/전자책 구매 안내')}
          </div>
          <p class="pd-default-story__body">
            결제 완료 후, 구매내역에서 7일 간 다운로드 받으실 수 있습니다. (기한 이후 다운로드를 원하실 경우
            재구매를 해주셔야 합니다.)<br />
            디지털/전자책 특성 상 전자상거래법 제 17조에 의거하여 구매 이후에는 어떠한 사유로도 교환 및 환불이
            불가합니다.
          </p>
        </div>
      </div>
      <div class="info_el">${makeProductStoryHtml(product_story)}</div>
      <div class="pd-info-group__hide">
        <button type="button" class="pd-info-group__btn">${ET('product_detail::unfold_btn')}</button>
      </div>
    </div>
    <div tab_name="pb_purchaseInfo" class="pd-contents__group">
      ${makeDtgPurchaseInfoHtml({ plus_crew, store, stores_product, stores_delivery_company })}
    </div>
    ${UtilS.htmlIf2(is_mobile && creator_summary, () =>
      new CreatorSummary({
        ...store,
        ...creator_summary,
        is_mobile,
        is_login,
        mode: 'backdrop',
      }).toHtmlSSR(),
    )}
    ${makeRecommendProductsHtml({
      store,
      mps_recommended_products,
      product_detail,
      is_mobile,
      klass: 'pd-contents__group',
    })}
    <div tab_name="fanLetter" class="pd-contents__group">
      ${makeFanletterHtml({ store, fan_letters, is_login, is_mobile })}
    </div>
    <div tab_name="review" class="pd-contents__group">
      ${makeProductReviewHtml({
        review_count: product_detail.review_meta.count,
      })}
    </div>
  `;
};

export const makeThumbSwiperHtml = ({ product_detail, product_n_viewing_count, is_mobile = false }) => {
  if (UtilS.isNessApp()) {
    return makeThumbSwiperHtmlNess({ product_detail });
  }

  const thumbnails = go(product_detail, sel('thumbnails.value'), (thumbs = []) => {
    const thumb_index = thumbs.findIndex((a) => a.is_thumb);
    const main_index = thumb_index === -1 ? 0 : thumb_index;
    return [...thumbs.slice(main_index), ...thumbs.slice(0, main_index)];
  });

  /**
   * @mps-only
   */
  return html`
    <div class="pd-preview">
      <div class="pd-preview__thumbs">
        ${go(
          thumbnails,
          zipWithIndexL,
          strMap(
            ([index, thumbnail_image]) => `
            <button class="pd-preview__thumbs-btn ${index === 0 ? 'active' : ''}" data-index="${index}">
              ${MpShopProductTmplS.thumbnail(product_detail, { thumbnail_image, width: 156 })}
            </button>`,
          ),
        )}
      </div>

      <div class="pd-preview__swiper swiper-container">
        ${new ProductBadgeListView({
          badges: convertToMpsBadgeListProps(product_detail.mpsProductDetail),
          options: {
            styles: {
              container: 'pd-preview__badges',
            },
            lang: ET.lang,
            size: ProductBadgeSize.medium,
            max_length: 3,
            state: 'MembershipWithLabel',
            baseTimestamp: Date.now(),
          },
        }).toHtmlSSR()}
        ${makeProductNViewingHtml({
          product_n_viewing_count,
          is_mobile,
        })}

        <div class="swiper-wrapper">
          ${go(
            thumbnails,
            zipWithIndexL,
            strMap(
              ([index, thumbnail_image]) => `
            <div class="swiper-slide ${index === 0 ? 'active' : ''}">
              ${MpShopProductTmplS.thumbnail(product_detail, { thumbnail_image, width: 1600 })}
            </div>
          `,
            ),
          )}
        </div>
      </div>
    </div>
  `;
};

/**
 * @ness-only
 * Pc 상품상세 상품 사진
 */
export const makeThumbSwiperHtmlNess = ({ product_detail }) => {
  const thumbnails = go(product_detail, sel('thumbnails.value'), (thumbs = []) => {
    const _thumbs = [...thumbs];
    const thumb_index = _thumbs.findIndex((a) => a.is_thumb);
    // const main_index = thumb_index === -1 ? 0 : thumb_index;
    return [..._thumbs.splice(thumb_index, 1), ..._thumbs];
  });

  // 마케팅 가격
  const pre_discount_price = sel('_.pre_discount_product.pre_discount_price', product_detail);
  const origin_price = creatorPriceOfProduct(product_detail);

  /* TODO: 할인 뱃지도 서비스에서 내려주도록 수정 @blan22 */
  // TODO: @ice
  if (pre_discount_price) {
    product_detail.nessProductDetail.discountPercentage =
      MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, origin_price);
  }

  return html`
    <div class="pd-preview">
      <div class="pd-preview__thumbs">
        ${go(
          thumbnails,
          zipWithIndexL,
          strMap(
            ([index, thumbnail_image]) => `
            <button class="pd-preview__thumbs-btn ${index === 0 ? 'active' : ''}" data-index="${index}">
              ${MpShopProductTmplS.thumbnail(product_detail, { thumbnail_image, width: 156 })}
            </button>`,
          ),
        )}
      </div>

      <div class="pd-preview__swiper swiper-container">
        <div class="swiper-wrapper">
          ${go(
            thumbnails,
            zipWithIndexL,
            strMap(
              ([index, thumbnail_image]) => `
            <div class="swiper-slide ${index === 0 ? 'active' : ''}">
              ${MpShopProductTmplS.thumbnail(product_detail, { thumbnail_image, width: 1600 })}
            </div>
          `,
            ),
          )}
        </div>
      </div>
    </div>
  `;
};
